import styled from 'styled-components'

import {tokens} from '@pleo-io/telescope'

import {useCompanyGuides} from '@product-web/api/deimos/company-guides'

import {Drawer} from '~/generic-ui/drawer'

import AdoptionAccordion from './accordion'
import {useAdoptionCentre} from './adoption-centre-context'
import AdoptionCentreFooter from './adoption-centre-footer'

export const AdoptionDrawer = () => {
    const {data: companyGuides} = useCompanyGuides()
    const {setDrawerOpen, isDrawerOpen} = useAdoptionCentre()

    const onDismiss = () => {
        setDrawerOpen(false)
    }

    return (
        <DrawerWrapper isOpen={isDrawerOpen} onDismiss={onDismiss} noBackdrop>
            <ContentWrapper>
                <AdoptionAccordion guides={companyGuides} closeAdoptionCentre={onDismiss} />
                <AdoptionCentreFooter closeAdoptionCentre={onDismiss} />
            </ContentWrapper>
        </DrawerWrapper>
    )
}
const DrawerWrapper = styled(Drawer)`
    max-width: 416px;
    min-width: 416px;
    /* stylelint-disable-next-line declaration-property-value-allowed-list */
    box-shadow: 0 6px 24px rgb(0 0 0 / 10%);
    position: fixed;
    top: 0;
`
const ContentWrapper = styled.div`
    background-color: ${tokens.shade000};
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`
